import { useEffect, useState } from 'react';
import { getLlmPrompts } from '../../api/api';

// Prompt lists per report type, shared by every text area on the page.
const cache = new Map();
function loadPrompts(reportType) {
  const key = reportType || '';
  if (!cache.has(key)) {
    cache.set(key, getLlmPrompts(null, { reportType })
      .then(res => res.data.filter(p => p.prompt_key !== '_global'))
      .catch((err) => { cache.delete(key); throw err; }));
  }
  return cache.get(key);
}

/**
 * Chooses which LLM prompt a text area generates with (stored in the block's
 * data.llmPrompt). No prompt = no Generoi button.
 */
export default function PromptTagSelect({ value, reportType, onChange, disabled }) {
  const [prompts, setPrompts] = useState(null);

  useEffect(() => {
    let cancelled = false;
    loadPrompts(reportType)
      .then(list => { if (!cancelled) setPrompts(list); })
      .catch(() => { if (!cancelled) setPrompts([]); });
    return () => { cancelled = true; };
  }, [reportType]);

  const known = !value || !prompts || prompts.some(p => p.prompt_key === value);

  // Opens the prompt in the LLM-promptit editor in a new tab (the report stays open).
  const editUrl = value
    ? `/llm-promptit?${new URLSearchParams({ prompti: value, ...(reportType ? { tyyppi: reportType } : {}) })}`
    : null;

  return (
    <span className="d-inline-flex align-items-center gap-1">
    <select
      className={`form-select form-select-sm ${known ? '' : 'is-invalid'}`}
      style={{ fontSize: 12, height: 28, padding: '0 28px 0 8px', width: 'auto', maxWidth: 220 }}
      value={value || ''}
      disabled={disabled || !prompts}
      onChange={(e) => onChange(e.target.value || null)}
      title={known ? 'LLM-prompti, jolla tämä tekstikenttä generoidaan' : `Promptia "${value}" ei löydy tai se on poistettu`}
      aria-label="LLM-prompti"
    >
      <option value="">{prompts ? 'Ei promptia' : 'Ladataan…'}</option>
      {!known && <option value={value}>{value} (puuttuu)</option>}
      {(prompts || []).map(p => (
        <option key={p.prompt_key} value={p.prompt_key}>{p.name}</option>
      ))}
    </select>
    {editUrl && known && (
      <a
        href={editUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="btn btn-sm btn-outline-secondary d-inline-flex align-items-center"
        style={{ fontSize: 12, height: 28, padding: '0 8px' }}
        title="Muokkaa promptia (avautuu uuteen välilehteen)"
      >
        <i className="bi bi-pencil me-1" />Muokkaa promptia
      </a>
    )}
    </span>
  );
}
